var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.2348 0C13.8778 0 12.5588 0.169169 11.2983 0.488126C10.2696 0.748447 9.73837 1.63691 9.56748 2.37546C9.36506 3.2503 8.81606 4.03839 7.97903 4.52165C7.20943 4.96597 6.33932 5.07035 5.53683 4.88112C4.79929 4.7072 3.76951 4.79003 3.08035 5.5943C1.79906 7.08962 0.788318 8.82506 0.125138 10.7247C-0.270789 11.8588 0.34265 12.8801 0.990343 13.4137C1.73798 14.0297 2.21156 14.9591 2.21156 16C2.21156 17.0409 1.73798 17.9703 0.990342 18.5863C0.342649 19.1199 -0.270791 20.1412 0.125135 21.2753C0.788241 23.1747 1.79883 24.91 3.07992 26.4052C3.76912 27.2096 4.79903 27.2924 5.53663 27.1184C6.33917 26.9291 7.20935 27.0335 7.97902 27.4778C8.81614 27.9611 9.36517 28.7494 9.56754 29.6243C9.73837 30.363 10.2696 31.2516 11.2985 31.5119C12.5589 31.8308 13.8779 32 15.2348 32C16.5917 32 17.9108 31.8308 19.1713 31.5119C20.2001 31.2515 20.7313 30.3629 20.9022 29.6243C21.1045 28.7494 21.6536 27.9611 22.4907 27.4778C23.2603 27.0335 24.1305 26.9291 24.933 27.1184C25.6706 27.2923 26.7005 27.2095 27.3897 26.4052C28.6707 24.91 29.6813 23.1747 30.3444 21.2753C30.7403 20.1411 30.1269 19.1199 29.4792 18.5863C28.7316 17.9703 28.258 17.0409 28.258 16C28.258 14.9591 28.7316 14.0297 29.4792 13.4137C30.1269 12.8801 30.7403 11.8589 30.3444 10.7247C29.6813 8.8251 28.6705 7.08966 27.3892 5.59435C26.7001 4.7901 25.6704 4.70725 24.9328 4.88114C24.1304 5.07034 23.2603 4.96596 22.4907 4.52165C21.6537 4.03839 21.1047 3.25032 20.9023 2.37549C20.7314 1.63696 20.2002 0.748525 19.1715 0.488193C17.9109 0.169193 16.5918 0 15.2348 0Z",
    fill: "#0036DD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.46512,
    cy: 4.46512,
    r: 4.46512,
    transform: "matrix(-1 0 0 1 19.6998 11.5352)",
    fill: "#0036DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.0038f3bcd70b3d625decb713b99e57e5.svg";
export { ForwardRef as ReactComponent };